/* PureState hero: gallery, blur strip, bundle picker (quantity radios), availability, add_and_checkout. No copy in JS. */
(function () {
  var doc = document, dm = !!(window.Shopify && Shopify.designMode);
  var reduced = function () { return matchMedia('(prefers-reduced-motion: reduce)').matches; };
  var root = function () { return doc.querySelector('product-info[data-ps-product-form]'); };
  var pubsub = function () { return typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'; };

  /* Dawn's product-form.js rewrites the button from window.variantStrings.addToCart → keep the hero label. */
  function syncLabel() {
    var r = root();
    if (!r || !r.dataset.psCtaLabel) return;
    window.variantStrings = window.variantStrings || {};
    window.variantStrings.addToCart = r.dataset.psCtaLabel;
  }
  /* add_and_checkout: after Dawn's own add (source product-form) go to /checkout. */
  function armCheckout() {
    var r = root();
    if (!r || r.dataset.psCtaMode !== 'add_and_checkout' || r.dataset.psArmed || !pubsub()) return;
    r.dataset.psArmed = '1';
    var delay = parseInt(r.dataset.psCheckoutDelay, 10) || 0;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (d) {
      if (d && d.source && d.source !== 'product-form') return;
      setTimeout(function () { location.href = '/checkout'; }, delay);
    });
  }
  function init() { syncLabel(); armCheckout(); }
  syncLabel();
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
  doc.addEventListener('shopify:section:load', init);

  /* Bonus tooltip <dialog> */
  doc.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ps-dialog]');
    var d = b && doc.getElementById(b.getAttribute('data-ps-dialog'));
    if (d && d.showModal) d.showModal();
  });

  if (!customElements.get('ps-gallery')) {
    customElements.define('ps-gallery', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.slider = this.querySelector('slider-component');
        this.list = this.querySelector('[id^="Slider-"]');
        if (!this.list) return;
        this.slider.addEventListener('slideChanged', function (ev) {
          var el = ev.detail && ev.detail.currentElement;
          if (el) self.setActive(el.dataset.slideId);
        });
        this.list.addEventListener('keydown', function (ev) {
          if (ev.key !== 'ArrowLeft' && ev.key !== 'ArrowRight') return;
          var btn = self.slider.querySelector(ev.key === 'ArrowLeft' ? 'button[name="previous"]' : 'button[name="next"]');
          if (btn && !btn.disabled) { ev.preventDefault(); btn.click(); }
        });
        this.addEventListener('click', function (ev) {
          var t = ev.target.closest && ev.target.closest('button[data-target]');
          if (t) { ev.preventDefault(); self.goTo(t.dataset.target); }
          var z = ev.target.closest && ev.target.closest('.ps-gallery__zoom');
          if (z) self.openModal(z.dataset.slideId);
        });
        doc.addEventListener('ps:bundle-change', function (ev) { self.swap(ev.detail && ev.detail.quantity); });
        if (dm) doc.addEventListener('shopify:block:select', function (ev) {
          var li = ev.target.closest && ev.target.closest('.ps-gallery__slide');
          if (li && self.contains(li)) self.goTo(li.dataset.slideId);
        });
        this.autoplay();
        var r = root();
        if (r && r.dataset.psSwapSlide === 'true') this.swap(r.dataset.psSelectedQty, true);
      }
      slide(id) { return this.list.querySelector('.ps-gallery__slide[data-slide-id="' + id + '"]'); }
      setActive(id) {
        this.querySelectorAll('.ps-gallery__slide').forEach(function (s) { s.classList.toggle('is-active', s.dataset.slideId === id); });
        this.querySelectorAll('button[data-target]').forEach(function (b) {
          var on = b.dataset.target === id;
          if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
          if (on && !reduced()) b.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        });
      }
      goTo(id, instant) {
        var s = this.slide(id);
        if (!s) return;
        this.list.scrollTo({ left: s.offsetLeft, behavior: instant || reduced() ? 'auto' : 'smooth' });
        this.setActive(id);
      }
      swap(qty, initial) {
        var r = root();
        if (!qty || !r || r.dataset.psSwapSlide !== 'true') return;
        var s = this.list.querySelector('.ps-gallery__slide[data-bundle-option="' + qty + '"]');
        if (!s) return;
        if (s !== this.list.firstElementChild) {
          this.list.prepend(s);
          this.querySelectorAll('.ps-gallery__thumbs, .ps-gallery__dots').forEach(function (ul) {
            var t = ul.querySelector('[data-target="' + s.dataset.slideId + '"]');
            var li = t && t.closest('li');
            if (li) ul.prepend(li);
          });
          if (this.slider.resetPages) this.slider.resetPages();
        } else if (initial) return;
        this.goTo(s.dataset.slideId, initial);
      }
      openModal(id) {
        var m = doc.getElementById('PsGalleryModal-' + this.dataset.section);
        var item = m && m.querySelector('[data-slide-id="' + id + '"]');
        if (item) setTimeout(function () { item.scrollIntoView({ block: 'start', behavior: 'auto' }); }, 50);
      }
      autoplay() {
        var nodes = this.querySelectorAll('deferred-media[data-autoplay-muted]');
        if (!nodes.length || reduced() || !('IntersectionObserver' in window) || (navigator.connection && navigator.connection.saveData)) return;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            io.unobserve(en.target);
            if (en.target.loadContent) en.target.loadContent(false);
          });
        }, { threshold: 0.4 });
        nodes.forEach(function (n) { io.observe(n); });
      }
    });
  }

  if (!customElements.get('ps-blur-strip')) {
    customElements.define('ps-blur-strip', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.mode !== 'marquee' || !('IntersectionObserver' in window)) return;
        var self = this;
        this.io = new IntersectionObserver(function (en) { self.classList.toggle('is-paused', !en[0].isIntersecting); });
        this.io.observe(this);
      }
      disconnectedCallback() { if (this.io) this.io.disconnect(); }
    });
  }

  if (!customElements.get('ps-bundle-picker')) {
    customElements.define('ps-bundle-picker', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.addEventListener('change', function (ev) {
          if (ev.target.classList.contains('ps-bundle__input')) self.update(true);
        });
        this.update(false);
      }
      update(emit) {
        var checked = this.querySelector('.ps-bundle__input:checked');
        var opt = checked && checked.closest('.ps-bundle__option');
        this.querySelectorAll('.ps-bundle__option').forEach(function (o) { o.classList.toggle('is-selected', o === opt); });
        if (!opt) return;
        var r = root(), qty = opt.dataset.quantity || '1', price = opt.dataset.psPriceText || '';
        if (r) { r.dataset.psSelectedQty = qty; r.dataset.psSelectedPrice = price; }
        if (emit) doc.dispatchEvent(new CustomEvent('ps:bundle-change', { bubbles: true, detail: { quantity: qty, priceText: price } }));
      }
    });
  }

  /* Server-rendered; swapped from the refetched HTML if Dawn ever publishes variantChange. */
  if (!customElements.get('ps-availability')) {
    customElements.define('ps-availability', class extends HTMLElement {
      connectedCallback() {
        if (!pubsub()) return;
        var self = this;
        this.off = subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
          var src = ev && ev.data && ev.data.html && ev.data.html.getElementById(self.id);
          if (src) self.replaceWith(src);
        });
      }
      disconnectedCallback() { if (typeof this.off === 'function') this.off(); }
    });
  }
})();
